export const FootnotesDataFormatter = (data) => {
    const temp = []
    for (let record of data) {
        temp.push({
            "field": record[0], "amount": record[1], "selected": record[2]
        })
    }
    return temp
}

export const FootnotesDataDeformatter = (data) => {
    const temp = []
    for (let record of data) {
        const innerlist = []
        innerlist.push(record["field"])
        innerlist.push(record["amount"])
        innerlist.push(record["selected"])
        temp.push(innerlist)
    }
    return temp
}

export const FootnotePageDataFormatter = (data) => {
    const temp = []
    for (let record of data) {
        temp.push({
            "field": record[0], "amount": record[1], "selected": record[2], "header": record[3]
        })
    }
    return temp
}

export const FootnotePageDataDeformatter = (data) => {
    const temp = []
    for (let record of data) {
        const innerlist = []
        innerlist.push(record["field"])
        innerlist.push(record["amount"])
        innerlist.push(record["selected"])
        temp.push(innerlist)
    }
    return temp
}

export const getUniqueLists = (lists) => {
    const seen = new Set();
    const uniqueLists = [];
  
    for (let list of lists) {
      const serializedList = JSON.stringify(list);
      
      // If the serialized list hasn't been added before, add it to the result
      if (!seen.has(serializedList)) {
        uniqueLists.push(list);
        seen.add(serializedList); // Mark this list as seen
      }
    }
  
    return uniqueLists;
  };

export const convertToInteger = (str) => {
    if (str.startsWith('(') && str.endsWith(')')) {
        // Remove the parentheses and convert to negative number
        const numStr = str.slice(1, -1).replace(/,/g, "");
        const num = parseInt(numStr);
        return -num;
    } else {
        // Return the number as is if it's not in the expected format
        const newStr = str.replace(/,/g, "")
        return parseInt(newStr);
    }
};

export const convertToBracketedString = (num) => {
    if (num < 0) {
        return `(${Math.abs(num).toLocaleString()})`;
    }
    return num;
};

export const updateTotalForFootnote = (rd) => {
    const values = []
    for (let record of rd) {
        if (record["field"].toLowerCase().includes("total")) {
            const total = values.reduce((acc, val) => acc + val, 0)
            record["amount"] = total > 0 ? total.toLocaleString() : convertToBracketedString(total)
            // console.log("TOTAL: ", total)
            values.length = 0
        } else {
            const val = record["amount"] !== "" && record["selected"] ? convertToInteger(record["amount"]) : 0
            values.push(val)
        }
    }
    return rd
}
